import { apiClient } from '@/api/client';
import { AccountSettingsSchema, type AccountSettings } from '../schemas/settings';

/**
 * Account settings endpoint (the data-layer seam for settings).
 *
 * Unlike every other entity, settings SKIP the mapper layer: the document is
 * camelCase end-to-end (see CONTEXT.md "Settings document casing"). The endpoint
 * still validates the response with `AccountSettingsSchema.parse`, which fills
 * defaults for any absent field, and returns the domain type unchanged.
 */

const SETTINGS_ENDPOINT = '/api/user/settings';

/**
 * Fetch the current user's account settings document.
 */
export async function getAccountSettings(): Promise<AccountSettings> {
  const data = await apiClient.get<unknown>(SETTINGS_ENDPOINT);
  return AccountSettingsSchema.parse(data);
}

/**
 * Partially update the account settings document (server merges on write) and
 * return the resulting full document.
 */
export async function updateAccountSettings(
  patch: Partial<AccountSettings>,
): Promise<AccountSettings> {
  const data = await apiClient.patch<unknown>(SETTINGS_ENDPOINT, patch);
  return AccountSettingsSchema.parse(data);
}
